import { TextField, TextFieldProps, InputAdornment } from '@mui/material'
import { styled } from '@mui/system'
import { Search as SearchSVG } from '../assets/svgs'

const ThemedTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    color: theme.palette.common.white,
    maxHeight: '4.8rem',
    backgroundColor: theme.palette.common[300],
    borderRadius: 9999,

    '& ::placeholder': {
      color: theme.palette.common[400],
    },
    '& fieldset': {
      borderWidth: 2,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '& input': {
      height: '2.4rem',
      paddingLeft: '0px !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
  },
}))

export const Search = ({ children, ...props }: TextFieldProps) => {
  return (
    <ThemedTextField
      {...props}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="start"
            sx={{
              marginRight: '1.7rem',
            }}
          >
            <SearchSVG />
          </InputAdornment>
        ),
      }}
    >
      {children}
    </ThemedTextField>
  )
}
